import { Injectable } from "@angular/core";

@Injectable()
export class AppCookieService {

  set(
    name: string,
    value: string,
    days = 1000,
    path = "/",
    secure = false,
    sameSite: "Lax" | "Strict" | "None" = "Lax"
  ) {
    const enc = encodeURIComponent(value);
    let cookie = `${encodeURIComponent(name)}=${enc};path=${path}`;
    if (typeof days === "number") {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      cookie += `;expires=${d.toUTCString()}`;
    }
    if (secure) cookie += ";secure";
    if (sameSite) cookie += `;SameSite=${sameSite}`;
    document.cookie = cookie;
  }

  // optional helpers
  get(name: string) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  delete(name: string, path = '/') {
    this.set(name, '', -1, path);
  }
}
